import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { HistoryDialog } from 'app/modules/wallforming/components/placement-history/types/historyDialog';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const HistorySettings = () => {
    const { t } = useTranslation();
    const setHistoryDialog = usePlacementStore((state) => state.setHistoryDialog);

    return (
        <Menu.Item
            leftSection={<Icon aria-hidden="true" icon="settings" />}
            onClick={() => setHistoryDialog(HistoryDialog.SETTINGS)}
        >
            {t('historySettings')}
        </Menu.Item>
    );
};
